import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { t } from 'i18next';

type Props = {
  openCompare: boolean;
  setOpenMapview: (a: boolean) => void;
  isDisabled: boolean;
};

export const MapButton = ({
  isDisabled,
  openCompare,
  setOpenMapview,
}: Props) => (
  <Button
    css={{
      'abyss-button-root': {
        width: '104px',
        border: 'solid 2px $core.color.brand.100',
        '&:active, &:focus, &:hover': {
          backgroundColor: '#D0F1F5',
        },
      },
    }}
    data-auto-testid="filter-buttons-map"
    data-testid="filter-buttons-map"
    isDisabled={isDisabled || openCompare}
    onClick={() => setOpenMapview(true)}
    size="$sm"
    variant="outline"
  >
    <Layout.Group>
      <IconSymbol color="$core.color.brand.100" icon="map" />
      <Text
        color={isDisabled || openCompare ? '#929496' : '$core.color.brand.100'}
        fontWeight="medium"
      >
        {t('Map')}
      </Text>
    </Layout.Group>
  </Button>
);
